<template>
	<div class="md-grey-page center-horizontal owner-register">
      <div class="page-banner"></div>
			<section class="container-white">
        <h2 class="page__main-title" v-if="!isAuth">{{ headerTitle }}<br>Owner Registration</h2>
        <h2 class="page__main-title" v-if="isAuth">{{ headerTitle }}<br>Register Property Owner Details </h2>

				<!-- Registration -->
				<section v-if="stage == 'registration' || stage == ''">
          <div v-if="isAuth" class="divider-title">
            Please add the contact details of the property owner.
          </div>
          <div v-else>
  					<div class="divider-title">If you’re thinking of selling or letting your property please add your contact details to arrange a valuation</div>
  					<div class="social-buttons">
  						<a id="facebook" href="#" @click.prevent="registerFB" class="mdc-button mdc-button--raised btn--spinner button button--facebook button-social">
  						<span class="mdc-button__icon" alt="facebook"></span></a>
  						<a id="linkedin" :href="linkedinUrl" class="mdc-button mdc-button--raised btn--spinner button button--linkedin button-social">
  						<span class="mdc-button__icon" alt="linkedin"></span></a>
  						<a id="google" href="" @click.prevent="registerGoogle" class="mdc-button mdc-button--raised btn--spinner button button--google button-social">
  						<span class="mdc-button__icon" alt="google"></span></a>
  					</div>
  					<div class="divider-title"><span>OR</span></div>
          </div>

          <div class="width-100 mdc-textfield mdc-textfield--upgraded mdc-textfield__no-margin-top">
             <input id="fullName" v-validate="'required'" type="text" v-model="fullName" class="mdc-textfield__input" name="fullname">
             <label for="fullName" class="mdc-textfield__label mdc-textfield__label--float-above">Full name</label>
          </div>
          <div class="width-100 mdc-textfield mdc-textfield--upgraded mdc-textfield__no-margin-top">
						 <input id="email" type="text" v-model="email" class="mdc-textfield__input" name="email">
						 <label for="email" class="mdc-textfield__label mdc-textfield__label--float-above">Email <span class="message--error">*</span></label>
					</div>
					<div class="width-100 mdc-textfield mdc-textfield--upgraded mdc-textfield__no-margin-top">
						 <input id="mobile" type="tel" v-model="mobile" class="mdc-textfield__input" name="mobile" inputmode="numeric" pattern="[0-9]*">
						 <label for="mobile" class="mdc-textfield__label mdc-textfield__label--float-above">Mobile Number <span class="message--error">*</span></label>
					</div>

          <div class="mdc-layout-grid" style="margin-top:15px">
						<label for="ukresident" class="mdc-switch-label" style="margin-right:15px" v-if="isAuth">Are they a resident of the UK</label>
            <label for="ukresident" class="mdc-switch-label" style="margin-right:15px" v-else>I am UK resident</label>
						<div class="mdc-switch">
						  <input id="ukresident" v-model="ukresident" type="checkbox" class="mdc-switch__native-control" />
						  <div class="mdc-switch__background">
						    <div class="mdc-switch__knob"></div>
						  </div>
						</div>
          </div>
					<div class="mdc-layout-grid">
             <a class="mdc-button mdc-button--raised mdc-button-submit btn--spinner btn--spinner__wide-btn width-100 owner-register__button applicant-update__button" v-if="isLoading">Register</a>
						 <a class="mdc-button mdc-button--raised mdc-button-submit btn--spinner btn--spinner__wide-btn width-100 owner-register__button" @click.prevent="registerManual" tabindex="0" v-if="!isLoading">Register</a>
					</div>
				</section>

        <section class="owner-register__badprop" v-else-if="stage == 'badprop'">
          The selected property does not exist or already has an owner.
        </section>
        <!-- Mobile  -->
        <section class="owner-register__mobile" v-else-if="stage == 'mobile'">
          <div class="divider-title">Please add your mobile number</div>
          <div class="width-100 mdc-textfield mdc-textfield--upgraded mdc-textfield__no-margin-top">
             <input id="mobile" type="tel" v-model="mobile" class="mdc-textfield__input" name="mobile" inputmode="numeric" pattern="[0-9]*">
             <label for="mobile" class="mdc-textfield__label mdc-textfield__label--float-above">Mobile Number <span class="message--error">*</span></label>
          </div>
          <div class="mdc-layout-grid owner-register__mobile-grid" style="margin-top:15px">
						<label for="ukresident" class="mdc-switch-label" style="margin-right:15px">I am UK resident</label>
						<div class="mdc-switch">
						  <input id="ukresident" v-model="ukresident" type="checkbox" class="mdc-switch__native-control" />
						  <div class="mdc-switch__background">
						    <div class="mdc-switch__knob"></div>
						  </div>
						</div>
          </div>
          <div class="mdc-layout-grid">
            <a class="mdc-button mdc-button--raised width-100 applicant-update__button" v-if="isLoading">Next</a>
						<a class="mdc-button mdc-button--raised width-100 applicant-update__button" @click.prevent="registerMobile" tabindex="0" v-if="!isLoading">Next</a>
					</div>
        </section>

        <!-- Address -->
        <section class="owner-register__address" v-else-if="stage == 'address'">
          <div v-if="!isAuth">
            <p class="text-left">Thank you.<br>Could you add the address of the property you are selling or renting, please?</p>
          </div>
          <div v-else>
            <p class="text-left">Please enter the address of the property that is to be sold or let</p>
          </div>

          <editable-address v-model="property.address" :isEditView="true" :options="{attentionSymbol: false, requiredNumbers: true, requiredFlatNum:false, startOnManual: false, goManualOnSuccess: false}"></editable-address>

          <!-- Property Status -->
          <div class="mdc-layout-grid owner-register__property-status">
            <label for="issoldlet" class="mdc-switch-label" style="margin-right:15px" v-if="!isAuth">I would like this property to be:</label>
            <label for="issoldlet" class="mdc-switch-label" style="margin-right:15px" v-else>This property is:</label>
            <div class="mdc-layout-grid mdc-layout-grid__inner">
                <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
                  <div class="btn btn--bordered" v-bind:class="{ 'btn--selected': property.serviceType == 'sales' }" @click.prevent="setSoldlet('sales')">
                    <span v-if="!isAuth">Sold</span>
                    <span v-else>For Sale</span>
                  </div>
                </div>
                <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
                  <div class="btn btn--bordered" v-bind:class="{ 'btn--selected': property.serviceType == 'lettings' }" @click.prevent="setSoldlet('lettings')">
                    <span v-if="!isAuth">Let</span>
                    <span v-else>To Let</span>
                  </div>
                </div>
            </div>

            <div class="mdc-layout-grid">
              <button class="mdc-button mdc-button--raised width-100 applicant-update__button" v-if="isLoading">Next</button>
              <button class="mdc-button mdc-button--raised width-100 applicant-update__button" @click="registerAddress" v-if="!isLoading">Next</button>
            </div>

          </div>
        </section>

        <!-- Address exists -->
        <section class="owner-register__address-exists" v-else-if="stage == 'addressexists'">
          <h2>
            {{ propertyAddress(property) }}
          </h2>
          <p class="text-center">This property is already in your database - Add Owner and skip property details?</p>
          <div class="mdc-layout-grid mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered" @click.prevent="registerAddressExists('yes')">Yes</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered" @click.prevent="registerAddressExists('no')">No</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
              <div class="btn btn--bordered" @click.prevent="registerAddressExists('diff')">This is a different property</div>
            </div>
          </div>
        </section>

        <!-- Address check -->
        <section class="owner-register__address-check" v-else-if="stage == 'addresscheck'">
					<h2>
            {{ propertyAddress(property) }}
          </h2>
          <p class="text-center" v-if="isAuth">Is this the same as their correspondence address?</p>
          <p class="text-center" v-if="!isAuth">Is this the same as your correspondence address?</p>
          <div class="mdc-layout-grid mdc-layout-grid__inner">
						<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
	            <div class="btn btn--bordered" @click.prevent="registerAddressCheck('no')">No</div>
						</div>
						<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
            	<div class="btn btn--bordered" @click.prevent="registerAddressCheck('yes')">Yes</div>
						</div>
          </div>
        </section>

        <!-- Correspondence address -->
        <section v-else-if="stage == 'address2'">
          <p class="text-center">Please add your correspondence address</p>

          <editable-address v-model="owner.address" :isEditView="true" :options="{attentionSymbol: false, requiredNumbers: true, startOnManual: false, goManualOnSuccess: false}"></editable-address>

          <br><br>
          <div class="mdc-layout-grid">
            <button class="mdc-button mdc-button--raised width-100 applicant-update__button" v-if="isLoading">Next</button>
            <button class="mdc-button mdc-button--raised width-100 applicant-update__button" @click="registerAddress2" v-if="!isLoading">Next</button>
          </div>
        </section>

        <!-- Bedrooms -->
				<section v-else-if="stage == 'bedrooms'" class="text-left subsection-bedrooms owner-register__property-bedrooms">
					<h2>
            {{ propertyAddress(property) }}
          </h2>
          <p class="text-center" v-if="isAuth">Bedrooms</p>
          <p class="text-center" v-if="!isAuth">How many bedrooms does this property have?</p>
          <option-buttons v-model="property.bedrooms" :items="[[0,'Studio'],[1, '1 bedroom'],[2, '2 bedrooms'],[3, '+']]" title="" :cols="2"></option-buttons>
          <br>
          <option-buttons v-model="property.bedrooms" :items="[[3, '3 bedrooms'],[4, '4 bedrooms'],[5, '5 bedrooms'],[6, '6 bedrooms'],[7, '7 bedrooms'],[8, '8 bedrooms'],[9, '9 bedrooms'],[10, '+10 bedrooms']]" title="" :cols="2" v-if="property.bedrooms > 2"></option-buttons>
          <br>
          <div class="mdc-layout-grid">
            <button class="mdc-button mdc-button--raised width-100 applicant-update__button" v-if="isLoading">Next</button>
            <button class="mdc-button mdc-button--raised width-100 applicant-update__button" @click="registerBedrooms" v-if="!isLoading">Next</button>
          </div>
				</section>

        <!-- Type of sale -->
				<section v-else-if="stage == 'types'" class="text-left owner-register__property-type">
					<h2>
            {{ propertyAddress(property) }}
          </h2>
          <p class="text-center">The property is a</p>
          <div class="mdc-layout-grid mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered" v-bind:class="{ 'btn--selected': property.type == 'house' }"  @click.prevent="setType('house')">House</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered" v-bind:class="{ 'btn--selected': property.type == 'flat' }" @click.prevent="setType('flat')">Flat</div>
            </div>
          </div>
          <br>
          <div class="mdc-layout-grid mdc-layout-grid__inner" v-if="property.type == 'house'">
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered" v-bind:class="{ 'btn--selected': property.subtype == 'terraced' }" @click.prevent="setSubType('terraced')">Terraced</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered" v-bind:class="{ 'btn--selected': property.subtype == 'semi' }" @click.prevent="setSubType('semi')">Semi</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered" v-bind:class="{ 'btn--selected': property.subtype == 'bungalow' }" @click.prevent="setSubType('bungalow')">Bungalow</div>
            </div>
          </div>
          <div class="mdc-layout-grid mdc-layout-grid__inner" v-if="property.type == 'flat'">
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered btn-multi" v-bind:class="{ 'btn--selected': property.subtype == 'studio' }" @click.prevent="setSubType('studio')">Studio</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered btn-multi" v-bind:class="{ 'btn--selected': property.subtype == 'flat' }" @click.prevent="setSubType('flat')">Flat</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered btn-multi" v-bind:class="{ 'btn--selected': property.subtype == 'apartment' }" @click.prevent="setSubType('apartment')">Apartment</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered btn-multi" v-bind:class="{ 'btn--selected': property.subtype == 'maisonette' }" @click.prevent="setSubType('maisonette')">Maisonette</div>
            </div>
          </div>
          <div class="mdc-layout-grid">
            <button class="mdc-button mdc-button--raised width-100 applicant-update__button" v-if="isLoading">Next</button>
            <button class="mdc-button mdc-button--raised width-100 applicant-update__button" @click="registerTypes" v-if="!isLoading">Next</button>
          </div>
				</section>

        <!-- Type of sale: sold -->
				<section v-else-if="stage == 'stage_sold'" class="text-left owner-register__property-type">
					<h2>
            {{ propertyAddress(property) }}
          </h2>
          <div class="mdc-layout-grid mdc-layout-grid__inner">
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered" v-bind:class="{ 'btn--selected': property.tenure == 'freehold' }" @click.prevent="settenure('freehold')">Freehold</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered" v-bind:class="{ 'btn--selected': property.tenure == 'leasehold' }" @click.prevent="settenure('leasehold')">Leasehold</div>
            </div>
            <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-2-phone">
              <div class="btn btn--bordered" v-bind:class="{ 'btn--selected': property.tenure == 'freehold-share' }" @click.prevent="settenure('freehold-share')">Share of freehold</div>
            </div>
          </div>

          <div class="mdc-layout-grid">
            <button class="mdc-button mdc-button--raised width-100 applicant-update__button" v-if="isLoading">Next</button>
            <button class="mdc-button mdc-button--raised width-100 applicant-update__button" @click="registerSold" v-if="!isLoading">Next</button>
          </div>
				</section>
        <!--
  				<section v-else-if="stage == 'skipprop'" class="text-left owner-register__applicant">
            <h3>Do you want to skip property details?</h3>
            <h4>
              {{ propertyAddress(property) }}
            </h4>
            <div class="mdc-layout-grid">
              <button class="mdc-button mdc-button--raised width-100 applicant-update__button" @click="skipProp(0)">No</button>
              <button class="mdc-button mdc-button--raised width-100 applicant-update__button" @click="skipProp(1)">Yes</button>
            </div>
          </section>

        -->
        <!-- Become an Applicant -->
				<section v-else-if="stage == 'beapplicant'" class="text-left owner-register__applicant">
          <div v-if="isAuth">
            <p>Would you like to register the owner as an applicant?</p>
            <p>You will have the option to add applicant criteria later.</p>
            <div class="mdc-layout-grid">
              <button class="mdc-button mdc-button--raised applicant-update__button" @click="registerApplicant('yes')">YES</button>
              <button class="mdc-button mdc-button--raised applicant-update__button" @click="registerApplicant('no')">NO</button>
            </div>
          </div>
          <div v-else>
  					<p>Are you also looking for a property? </p>
            <p>If you would like to receive property alerts, please fill out a short form with your preferences and we’ll keep you up to date with the latest properties.</p>
            <div class="mdc-layout-grid text-center">
              <a class="mdc-button mdc-button--raised applicant-update__button" href="javascript:;" @click.prevent="registerApplicant('yes')">Yes, I would like to receive updates</a>
              <a href="javascript:;" @click.prevent="registerApplicant('no')">Maybe later</a>
            </div>
          </div>
				</section>

				<!-- Stage Registration Success -->
				<section v-else-if="stage == 'finish'" class="text-left owner-register__registration-success">
          <div v-if="isAuth">
            <p>The property owner and property are now registered in your BestAgent account.</p>
            <div class="mdc-layout-grid text-center">
              <a class="mdc-button mdc-button--raised mdc-button-submit owner-register__button" href="javascript:;" @click.prevent="$router.push('/owners/'+owner.ownerId)">Go to Owner Profile</a><br>
              <a class="mdc-button mdc-button--raised mdc-button-submit owner-register__button" href="javascript:;" @click.prevent="$router.push('/properties/'+propertyId)">Go to Property Page</a><br>
              <a class="mdc-button mdc-button--raised mdc-button-submit owner-register__button" href="javascript:;" @click.prevent="$router.push('/')">Go to my Dashboard</a>
            </div>
          </div>
          <div v-else>
            <p>Thank you for registering your details with us, we will be in touch soon to discuss how we can help you.</p>
            <div class="mdc-layout-grid text-center">
              <a class="mdc-button mdc-button--raised owner-register__button" :href="companyWPsite" target="_blank" v-if="companyWPsite && companyWPsite != ''">View available properties</a>
              <a href="javascript:;" @click.prevent="$router.push('/')">Close</a>
            </div>
          </div>
				</section>

				<!-- Stage Registration Failure -->
				<section v-if="errorMsg.length > 0">
					<p class="message--error" v-html="errorMsg"></p>
				</section>

			</section>

			<div class="applicant-reg__ba-logo">
				<a href="https://bestagent.co.uk"><img class="" src="/static/img/logo_circle.png" alt=""></a>
			</div>
	</div>
</template>

<script>
import axios from 'axios';
import utils from '@/libs/mixins.js';
import qs from 'querystring';
import { init as initFB } from '@/libs/providers/fb';
import { init as initGoogle } from '@/libs/providers/google';
import EditableAddress from '../components/editable-items/EditableAddress.vue';
import OptionButtons      from '../components/OptionButtons.vue';
import api from '@/libs/api.js';
import {isLoggedIn} from '@/libs/auth0.js';

function validatePhoneUK(phone){
  const regex1 = /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/; // Phone number
  const regex2 = /^(\+44\s?7\d{3}|\(?07\d{3}\)?)?\s?\d{3}\s?\d{3}$/; // Mobile number
  const regex3 = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)?\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/; // Mixed
  if (regex1.test(String(phone)) || regex2.test(String(phone)) || regex3.test(String(phone))) {
    return true;
  } else {
    return false;
  }
}
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
export default {
	props: {
		linkedin: {
			type: Boolean,
			default: false
		}
	},
	data: function() {
		return {
      isLoading: true,
			companyId: 0,
			companyWPsite: '',
      ukresident: 0,
      iscoraddr: false,
      type: '',
      subtype: '',
      issoldlet: '',
      headerTitle: '',
			companyName: '',
      companyLogo: '',
			fullName: '',
			email: '',
      bedrooms: 0,
      address: {},
      address2: {},
			mobile: '',
      provider: 'manual',
			stage: '',
			errorMsg: '',
      isAgent: false,
      isAuth: false,
      propertyId: undefined,
      owners: [],
      owner: {
        address: {}
      },
      addingOwnerToProperty: false,
      property: {
        address: {},
        serviceType: '',
        type: '',
        tenure: '',
        subtype: '',
        status: '',
        bedrooms: 0
      },
      saving: false,
      pathSave: '/save'
		}
	},
  created: async function() {
    // check if logged in
    this.isAuth = this.$route.meta.isReallyAuth ? this.$route.meta.isReallyAuth : false;
  },
	mounted: async function() {
		const that = this;
		// check linkedIn
		if(this.linkedin) {
			this.showSpinner('linkedin');
			this.companyId = this.$route.query.state;
			this.registerLinkedin();
		} else {
			this.companyId = this.$route.params.companyId;
		}
		if (this.$route.params.ownerId) {
			setTimeout(function() {
				that.owner.ownerId = that.$route.params.ownerId;
	      that.stage = 'address';
			},1000);

		}

		if (this.$route.params.propertyId) {
      this.propertyId = this.$route.params.propertyId;
			this.property = await api({ endpoint: this.config.services.owners, path: '/p/'+this.companyId+'/'+this.$route.params.propertyId, method: 'GET' });
      //if (!this.property || this.property.ownerId) {
      //  this.stage = 'badprop';
      //} else {
        this.addingOwnerToProperty = true;
  			this.owner.property = this.property;
        this.address = this.property.address;
        this.bedrooms = this.property.bedrooms;
        this.type = this.property.type;
        this.subtype = this.property.subtype;
        this.issoldlet = this.property.serviceType;
      //}
		}

    initFB();
    initGoogle();

    if (this.isAuth) {
      try {
        const os = await api({endpoint: this.config.services.owners, path: '/', method: 'GET'});
        that.isAgent = true;
        if (os && os.length) {
          that.owners = os;
        } else {
          that.owners = [];
        }
      } catch(e) {
        // Avoid unknown agents
        console.log('You no agent',e.message);
        this.$router.push("/");
        return false;
      }
    }

    if (!this.isAgent) {
      this.pathSave += '/'+this.companyId;
    }
    that.isLoading = false;
		axios.get(this.config.services.companies + '/companyName/' + this.companyId).then(function(response) {
			that.companyName = response.data;
      axios.get(that.config.services.companies + '/companyLogo/' + that.companyId).then(function(response) {
        that.companyLogo = response.data;
        that.headerTitle = (that.companyLogo && that.companyLogo != '') ? `<img src="${s3url(that.companyLogo, 'small')}" />` : that.companyName.toUpperCase();
        axios.get(that.config.services.companies + '/companySite/' + that.companyId).then(function(response) {
          if (typeof response.data == 'string') {
            that.companyWPsite = response.data;
          }
        }).catch(function(error) {
          console.error('error getting company site:', error);
        });
      }).catch(function(error) {
        console.error('error getting company logo:', error);
      });
		}).catch(function(error) {
			console.error('error getting company name:', error);
		});
	},
	mixins: [utils],
	components: {
		'option-buttons': OptionButtons,
		'editable-address': EditableAddress
	},
	computed: {
		linkedinUrl() {
			const data = qs.stringify({
					'response_type' : 'code',
					'redirect_uri' : `${process.env.BASE_URL}/${ this.isAuth ? 'registerowner' : 'register-owner' }/linkedin/callback`,
					'client_id' : '78dyng07s6xrbc',
					'client_secret' : 'w104AJpWr4f99wQA',
					'state' : this.companyId
			});
			return `https://www.linkedin.com/oauth/v2/authorization?${data}`;
		}
	},
	methods: {
    skipProp(skip) {
      if (skip) {
        this.stage = 'addresscheck';
      } else {
        this.stage = 'address';
      }
    },
    localCheckEmail(email) {
      if (this.isAgent != true) {
        return false;
      }
      const found = this.owners.filter(o => {
        return email == o.email
      });
      if (found && found.length) {
        return process.env.BASE_URL+"/owners/"+found[0].ownerId;
      } else {
        return false;
      }
    },
    localCheckMobile(mobile) {
      if (this.isAgent != true) {
        return false;
      }
      const found = this.owners.filter(o => {
        return mobile == o.mobile
      });
      if (found && found.length) {
        return process.env.BASE_URL+"/owners/"+found[0].ownerId;
      } else {
        return false;
      }
    },
		registerFB() {
			const that = this;
      this.provider = "facebook";
			this.showSpinner('facebook');
			window.FB.login(function (response) {
				if (response.authResponse) {
					FB.api('/me', {fields: 'name,email'}, function (response) {
						that.fullName = response.name;
						that.email = response.email;
            that.mobileCheckNext('address', true);
					});
				}
			}, {scope: 'email'});
		},
		registerGoogle() {
			const that = this;
      this.provider = "google";
			this.showSpinner('google');
			window.gapi.auth2.getAuthInstance().signIn().then(function(user) {
				const profile = user.getBasicProfile();

				that.fullName = profile.getName();
				that.email = profile.getEmail();

        that.mobileCheckNext('address', true);
			});
		},
		registerLinkedin() {
			const that = this;
			const code = this.$route.query.code;
			const state = this.$route.query.state;
      this.provider = "linkedin";

			axios.post(this.config.services.companies + '/linkedInProfile', {
        source: this.isAuth ? 'registerowner' : 'register-owner',
				code: code,
				state: state
			}).then(function(response) {
				that.fullName = `${response.data.firstName} ${response.data.lastName}`;
				that.email = response.data.emailAddress;
        that.mobileCheckNext('address', true);
			}).catch(function(error) {
				console.error('error:', error);
			});
		},
		registerManual() {
      this.provider = 'manual';
      this.mobileCheckNext('address');
		},
    async mobileCheckNext(next, bypassError) {
      const that = this;
      if (!this.email || this.email == '' || !this.fullName || this.fullName == '') {
        this.stage = 'registration';
        this.errorMsg = 'Please fill all your information.';
        return false;
      }

      if (!validateEmail(this.email)) {
        if (!bypassError)this.errorMsg = 'This email is not valid.';
        return false;
      }

      if ((!this.mobile || this.mobile == '') || !validatePhoneUK(this.mobile)) {
        if (!bypassError)this.errorMsg = 'This mobile number is not valid.';
        this.stage = 'mobile';
        return false;
      } else {
        const thereisMobile = this.localCheckMobile(this.mobile);
        if (thereisMobile) {
          this.errorMsg = `There is already an owner registered with these details, view their profile <a href="${thereisMobile}">here</a>.`;
          return false;
        }
        const thereisEmail = this.localCheckEmail(this.email);
				if (thereisEmail) {
          this.errorMsg = `There is already an owner registered with these details, view their profile <a href="${thereisEmail}">here</a>.`;
          return false;
        }
      }
			this.errorMsg = '';
      if (this.addingOwnerToProperty) {
        await this.saveOwner();
        this.stage = 'addresscheck';
      } else {
        this.stage = next;
      }
    },
		async saveOwner() {
      if (this.saving === true) {
        return false;
      }
      this.saving = true;
      this.isLoading = true;
			let bodysend = {
				companyId: this.companyId,
				email: this.email,
				fullName: this.fullName,
				isuk: this.ukresident,
				mobile: this.mobile
			};
			if (this.owner.address) {
				bodysend.address = this.owner.address;
			}
			if (this.property && this.property.address) {
				bodysend.property = this.property;
			}
			const owner = await api({endpoint: this.config.services.owners, path: this.pathSave, method: 'POST', body: bodysend});
			if (owner && owner.ownerId) {
				this.owner = owner;
        if (!this.owner.address)
				    this.owner.address = {};

        if (!this.property || !this.property.address) {
  				this.property = {
  					address: {},
  					serviceType: '',
  					type: '',
  					subtype: '',
  					tenure: '',
  					status: '',
  					bedrooms: 0
  				};
        }
			}
      this.saving = false;
      this.isLoading = false;
		},
    async reSaveOwner() {
      if (this.saving === true) {
        return false;
      }
      this.saving = true;
      let ownersend = this.owner;
      ownersend.property = this.property;
      const owner = await api({endpoint: this.config.services.owners, path: this.pathSave, method: 'POST', body: ownersend});
      if (owner && owner.saved === true) {
        if (owner.prop && owner.prop.propertyId) {
          this.property.propertyId = owner.prop.propertyId;
          this.owner.property.propertyId = owner.prop.propertyId;
          this.propertyId = owner.prop.propertyId;
        }
      }
      this.saving = false;
    },
		registerMobile() {
			//this.register(this.fullName, this.email, this.mobile, this.provider);
      this.mobileCheckNext('address');
		},
    async addressExistsTrigger() {
      this.isLoading = true;
      let ownersend = this.owner;
      ownersend.property = this.property;
      const q = await api({ endpoint: this.config.services.owners, path: '/addressexists', method: 'POST', body: {action: 'check' , owner: ownersend} });
      this.isLoading = false;
      if (!q || !q.found || q.found == false) {
        return false;
      } else {
        this.property.propertyId = q.found;
        return true;
      }
    },
    async registerAddress() {
      await this.saveOwner();
      if (this.isAgent) {
        const exists = await this.addressExistsTrigger();
        if (exists) {
          this.stage = 'addressexists';
        } else {
          this.stage = 'bedrooms';
        }
      } else {
        this.stage = 'bedrooms';
      }
		},
    async registerAddressExists(a) {
      let q;
      this.isLoading = true;
      let ownersend = this.owner;
      ownersend.property = this.property;

      if (a == 'yes') { // add owner to property
        q = await api({ endpoint: this.config.services.owners, path: '/addressexists', method: 'POST', body: {action: 'set' , owner: ownersend} });
        this.stage = 'finish';
      } else if (a == 'no') { // update property details
        q = await api({ endpoint: this.config.services.owners, path: '/addressexists', method: 'POST', body: {action: 'set' , owner: ownersend} });
        this.stage = 'addresscheck';
      } else if (a == 'diff') { // do all normal its different
				if (this.property.propertyId)
        	delete this.property.propertyId;
        this.stage = 'bedrooms';
      } else {
        this.stage = 'bedrooms';
      }
      this.isLoading = false;
		},
    async registerAddressCheck(iscoraddr) {
      if (iscoraddr == 'yes') {
        this.owner.address = this.property.address;
        if (!this.owner.applicantId || this.owner.applicantId == '') {
          this.stage = 'beapplicant';
        } else {
          await this.reSaveOwner();
          this.stage = 'finish';
        }
      } else {
        this.stage = 'address2';
      }
		},
    async registerAddress2() {
      await this.reSaveOwner();
      if (!this.owner.applicantId || this.owner.applicantId == '') {
        this.stage = 'beapplicant';
      } else {
        this.stage = 'finish';
      }
		},
    registerBedrooms() {
			this.stage = 'types';
		},
    async registerTypes() {
      if (this.property.serviceType == 'lettings') {
        this.isLoading = true;
        await this.reSaveOwner();
        this.stage = 'addresscheck';
        this.isLoading = false;
      } else {
        this.stage = 'stage_sold';
      }
		},
    async registerSold() {
      let ownersend = this.owner;
      await this.reSaveOwner();
      this.stage = 'addresscheck';
      this.isLoading = false;
		},
    async registerApplicant(yesno) {
      this.isLoading = true;
      await this.reSaveOwner();

      if (yesno == 'yes') {
        const got = await api({endpoint: this.config.services.owners, path: `/toapplicant/${this.companyId}/${this.owner.ownerId}`, method: 'GET'});
        this.isLoading = false;
        if (got && typeof got == 'string' && got != '') {
          let reurl = got.replace(/http(s)?\:\/\/[^\/]+/i,"");
          //console.log(reurl);
          //window.open(got, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
          this.$router.push(reurl);
          this.stage = 'finish';
        }
      } else {
        this.stage = 'finish';
      }
      this.isLoading = false;
		},
		showSpinner(id) {
			var element = document.getElementById(id);
			element.classList.add('btn-spin--visible');
		},
		hideSpinner(id) {
			var element = document.getElementById(id);
			element.classList.remove('btn-spin--visible');
		},
		titleCase: function(str) {
   		var splitStr = str.toLowerCase().split(' ');
			for (var i = 0; i < splitStr.length; i++) {
				splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
			}
			// Directly return the joined string
			return splitStr.join(' ');
		},
    setSoldlet: function(type) {
      this.property.serviceType = type;
      //this.$set(this, 'owner', this.owner);
      //this.property.serviceType = type;
      //this.$set(this.owner, 'owner', true);
      //await this.$nextTick();
    },
    settenure: function(type) {
      this.property.tenure = type;
    },
    setType: function(type) {
      this.property.type = type;
    },
    setSubType: function(type) {
      this.property.subtype = type;
    },
	}
}
</script>
<style>
.btn-multi {
  /* display:block;
  float:left;
  margin-left:15px;
  margin-right:15px;
  margin-top:15px */
}
</style>



// WEBPACK FOOTER //
// src/pages/Owner-Reg.vue